module.exports = __webpack_public_path__ + "img/vertical_4_4_8023.85cb9135.png";